module.exports = __webpack_public_path__ + "static/media/item_17_7_comp.4b33bda1.png";